import {
  AnalysisConfigurationFeatureDTO,
  AnalysisConfigurationFeatureSectionDTO,
  AnalysisConfigurationFeatureSubSectionDTO,
  AnalysisFeatureDTO,
  AnalysisSectionDTO,
} from "@models/platform-analysis/entities/steps/feature";
import * as Yup from "yup";

export const saveFeatureSelectionAsTemplateValidators = Yup.object().shape({
  name: Yup.string()
    .nullable(true)
    .required("Feature template must has a name"),
});

export const compiledFeatureAnalysisSelections = (
  originalSections: AnalysisSectionDTO[],
): AnalysisConfigurationFeatureSectionDTO[] =>
  originalSections?.map(compileConfigurationFeatureSection) || [];

const compileConfigurationFeatureSection = ({
  id = "",
  name = "",
  description = "",
  order,
  iconUrl,
  totalFeature,
  totalSelectedFeature,
  subSections = [],
}: AnalysisSectionDTO): AnalysisConfigurationFeatureSectionDTO => ({
  id,
  name,
  isSelected: false,
  description,
  order,
  iconUrl,
  totalFeature,
  totalSelectedFeature,
  subSections: subSections.map((subSection) =>
    compileConfigurationFeatureSubSection(subSection, id),
  ),
});

const compileConfigurationFeatureSubSection = (
  {
    id = "",
    name = "",
    description = "",
    order,
    iconUrl,
    totalFeature,
    totalSelectedFeature,
    features = [],
  }: AnalysisSectionDTO,
  parentSectionId: string,
): AnalysisConfigurationFeatureSubSectionDTO => ({
  id,
  parentSectionId,
  name,
  isSelected: false,
  description,
  order,
  iconUrl,
  totalFeature,
  totalSelectedFeature,
  subSections: [],
  features: features.map(compileConfigurationFeature),
});

const compileConfigurationFeature = ({
  id = "",
  name = "",
  description = "",
  isEssential = false,
  order,
}: AnalysisFeatureDTO): AnalysisConfigurationFeatureDTO => ({
  id,
  name,
  description: description || "",
  isSelected: true,
  isEssential,
  order,
});
